import {ListItem} from "@domain/common/list-view/list-item";
import {CompteApiAutorisation} from "./compte-api-autorisation";

/**
 * Compte API
 *
 * @author Guillaume TRAVOT
 * @date 08/12/2025
 */
export class CompteApi implements ListItem {
    /** ID du compte */
    idCompte: number;

    /** Compte personnel */
    comptePersonnel: boolean;

    /** Identifiant du compte */
    identifiant: string;

    /** Libellé du compte */
    libelle: string;

    /** Email du compte */
    email: string;

    /** Dernière connexion */
    derniereConnexion: Date;

    /** Date de clôture */
    dateCloture: Date;

    /** Compte actif */
    actif: boolean;

    /** Compte verrouillé */
    verrouille: boolean;

    /** Description */
    description: string;

    /** Liste des droits pour chaque catégorie de l'API */
    listeAutorisations: CompteApiAutorisation[];

    /**
     * Constructeur
     */
    constructor(dto?: any) {
        if (dto) {
            this.idCompte = dto.idCompte;
            this.comptePersonnel = dto.comptePersonnel;
            this.identifiant = dto.identifiant;
            this.libelle = dto.libelle;
            this.email = dto.email;
            this.derniereConnexion = dto.derniereConnexion;
            this.dateCloture = dto.dateCloture;
            this.actif = dto.actif;
            this.verrouille = dto.verrouille;
            this.description = dto.description;
            this.listeAutorisations = dto.listeAutorisations?.map(compteApiAutorisation => new CompteApiAutorisation(compteApiAutorisation) ) ?? [];
        }
    }
    /**
     * Récupération de la clé unique de l'élément
     *
     * @returns L'identifiant du compte API
     */
    getKey(): string { return this.idCompte.toString(); }
}